import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";

export default function DigestUnsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ busy: true, msg: "" });
  useEffect(() => {
    api.post("/digest/unsubscribe", { u: params.get("u") || "", t: params.get("t") || "" })
      .then(() => setState({ busy: false, ok: true, msg: "You've been unsubscribed from the weekly insights digest." }))
      .catch((e) => setState({ busy: false, ok: false, msg: errMsg(e) }));
  }, [params]);
  return (
    <div className="max-w-md mx-auto my-24 bg-[#0F172A]/80 border border-slate-800 rounded-lg p-8 text-center space-y-4" data-testid="digest-unsubscribe">
      <h1 className="text-2xl font-bold">Weekly digest</h1>
      <p className={`text-sm ${state.ok === false ? "text-red-400" : "text-slate-300"}`} data-testid="digest-unsubscribe-msg">{state.busy ? "Updating your preference…" : state.msg}</p>
      {!state.busy && <p className="text-xs text-slate-500">You can turn it back on anytime under <Link to="/account" className="text-[#F58B23] hover:underline">My Account</Link>.</p>}
    </div>
  );
}
